/**
 * @fileoverview Workspace Workflow Roles (MOR-748)
 *
 * URL: /dashboard/workflow-roles
 *
 * Firm-defined workflow roles (Partner, Manager, Analyst, …) that workflow
 * tasks can be assigned to instead of a fixed user. Who fills each role is
 * chosen per job, so one workflow serves every team. Lives beside Statuses
 * and Labels under the workspace Calendar section. Admin/owner can create,
 * edit, recolour and reorder.
 *
 * - Convex: tasks.workflowRoles.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { WorkflowRolesManager } from "@/components/settings/tasks/WorkflowRolesManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/workflow-roles",
)({
  component: WorkflowRolesPage,
});

function WorkflowRolesPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <WorkflowRolesManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage workflow roles.
        </div>
      )}
    </div>
  );
}
